"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var splide_1 = __importDefault(require("@splidejs/splide"));
var constants_1 = require("../data/constants");
var ReferencesList = /** @class */ (function (_super) {
    __extends(ReferencesList, _super);
    function ReferencesList() {
        var _this = _super.call(this, constants_1.DATA_FILTER_LIST_REFERENCES) || this;
        if (!_this.getElement())
            return _this;
        // Observe items for lazy loading
        _this.observeItems();
        // Observe filter list when ajax loads new elements
        _this.observeNode(_this.getElement(), true);
        _this.observeNode(_this.getElement(), false);
        return _this;
    }
    // IntersectionObserver for lazy loading
    ReferencesList.prototype.observeItems = function () {
        // Get current ajax generated items
        this.items = this.getElement().querySelectorAll("[".concat(constants_1.DATA_REFERENCE_LIST_ITEM, "]"));
        var observer = new IntersectionObserver(this.onChange);
        for (var i = 0; i < this.items.length; i++) {
            observer.observe(this.items[i]);
        }
    };
    // Show items if observer sees them
    ReferencesList.prototype.onChange = function (entries, observer) {
        for (var i = 0; i < entries.length; i++) {
            var target = entries[i].target;
            // Get img nodes of current item the observer is looking at
            this.itemImages = target.querySelectorAll('[data-item-image]');
            if (entries[i].isIntersecting) {
                target.classList.add('show');
                for (var k = 0; k < this.itemImages.length; k++) {
                    this.itemImages[k].src = this.itemImages[k].dataset.src;
                }
                observer.unobserve(target);
            }
            else {
                target.classList.remove('show');
            }
        }
    };
    // MutationObserver for filter-list ajax changes
    // FROM: https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
    ReferencesList.prototype.observeNode = function (targetNode, isSubtreeEnabled) {
        var _this = this;
        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true, subtree: isSubtreeEnabled };
        // Callback function to execute when mutations are observed
        var callback = function (mutationsList, observer) {
            // Observe newly created items from filter list update
            for (var i = 0; i < mutationsList.length; i++) {
                if (mutationsList[i].type === 'childList') {
                    if (isSubtreeEnabled) {
                        // Re-observe all newly created items
                        _this.observeItems();
                    }
                    else {
                        // Rebuild sliders on filter content changes (and subtree disabled)
                        _this.rebuildSlider();
                    }
                }
            }
        };
        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    };
    ReferencesList.prototype.rebuildSlider = function () {
        var _a;
        // Slider - References list items
        (_a = this.getChildElements("[".concat(constants_1.DATA_SLIDER_REFERENCES, "]"))) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
            var splide = new splide_1.default(element, {
                type: 'loop',
                perPage: 1,
                autoplay: true,
                rewind: true,
                speed: 1000,
                arrows: false,
                pagination: false,
                lazyLoad: 'nearby',
                mediaQuery: 'min',
                breakpoints: {
                    1440: {
                        arrows: true
                    },
                }
            });
            splide.mount();
        });
    };
    return ReferencesList;
}(AbstractComponent_1.default));
exports.default = ReferencesList;
